import { useEffect } from "react";
import { toast } from "sonner";
import { isAutoComfort, setComfort } from "@/lib/comfort";

const SEEN = "spur_comfort_auto_seen";
const seen = () => {
  try {
    return !!sessionStorage.getItem(SEEN);
  } catch {
    return true;
  }
};

/** One-time notice when Comfort Mode switched itself on because of the device's display settings. */
export default function ComfortAutoNotice() {
  useEffect(() => {
    if (!isAutoComfort() || seen()) return;
    // Deferred so sonner's <Toaster> (a later sibling in App) has subscribed; SEEN is written
    // inside the timer so React StrictMode's double effect run can't swallow the notice.
    const t = setTimeout(() => {
      if (seen()) return;
      try {
        sessionStorage.setItem(SEEN, "1");
      } catch {
        /* ignore */
      }
      toast("Comfort mode is on", {
        id: "comfort-auto",
        description: "Your device asks for larger text or more contrast, so we switched to warmer colours and bigger type.",
        duration: 9000,
        action: { label: "Turn off", onClick: () => setComfort(false) },
      });
    }, 800);
    return () => clearTimeout(t);
  }, []);
  return null;
}
